import data from '@emoji-mart/data';
import { init } from 'emoji-mart';
import type { Emoji as EmojiMartEmoji } from 'emoji-mart';

init({ data });

// as of v5 of emoji mart this is how you're supposed to it i guess
// https://github.com/missive/emoji-mart?tab=readme-ov-file#-emoji-component
const EmojiComponent = ({
  emoji,
  size,
}: {
  emoji: Partial<(typeof EmojiMartEmoji.Props)>;
  size: number;
  // this is a custom element defined when we call `init` above
  // @ts-expect-error
}) => <em-emoji {...emoji} size={size} />;

export default EmojiComponent;
